import { StyleSheet, Text, View } from 'react-native';
import { colors, control, fontFamily, space, type } from '~/ui/tokens';
import { IconButton } from './IconButton';

interface StepperProps {
  label: string;
  sublabel?: string;
  value: number;
  onChange: (value: number) => void;
  min?: number;
  max?: number;
}

export function Stepper({ label, sublabel, value, onChange, min = 0, max = 99 }: StepperProps) {
  return (
    <View style={styles.row}>
      <View>
        <Text style={styles.label}>{label}</Text>
        {sublabel ? <Text style={styles.sublabel}>{sublabel}</Text> : null}
      </View>
      <View style={styles.controls}>
        <IconButton
          icon="remove"
          diameter={32}
          size={16}
          disabled={value <= min}
          onPress={() => onChange(value - 1)}
        />
        <Text style={styles.value}>{value}</Text>
        <IconButton
          icon="add"
          diameter={32}
          size={16}
          disabled={value >= max}
          onPress={() => onChange(value + 1)}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: space.compact,
  },
  label: {
    fontFamily: fontFamily.medium,
    ...type.bodyLarge,
    color: colors.ink,
  },
  sublabel: {
    fontFamily: fontFamily.regular,
    ...type.metadata,
    color: colors.inkFaint,
    marginTop: space.micro,
  },
  controls: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: space.internal,
  },
  value: {
    fontFamily: fontFamily.semibold,
    ...control.inputValue,
    color: colors.ink,
    minWidth: 20,
    textAlign: 'center',
  },
});
